import { render, staticRenderFns } from "./BidAcceptOrReject.vue?vue&type=template&id=94a32162&"
import script from "./BidAcceptOrReject.vue?vue&type=script&lang=js&"
export * from "./BidAcceptOrReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports